const chipPalette = (tokens) => {
    return {
        font: {
            family: tokens.chipFontFamily,
            weight: tokens.chipFontWeight,
            letterSpacing: tokens.chipLetterSpacing
        },
        size: {
            medium: {
                height: tokens.chipSizeMediumHeight,
                padding: {
                    right: tokens.chipSizeMediumPaddingRight,
                    left: tokens.chipSizeMediumPaddingLeft
                },
                spaceBetween: tokens.chipSizeMediumSpaceBetween,
                fontSize: tokens.chipMFontSize
            },
            large: {
                height: tokens.chipSizeLargeHeight,
                padding: {
                    right: tokens.chipSizeLargePaddingRight,
                    left: tokens.chipSizeLargePaddingLeft
                },
                spaceBetween: tokens.chipSizeLargeSpaceBetween,
                fontSize: tokens.chipLFontSize
            },
            input: {
                height: tokens.chipSizeInputHeight,
                padding: {
                    right: tokens.chipSizeInputPaddingRight,
                    left: tokens.chipSizeInputPaddingLeft
                },
                spaceBetween: tokens.chipSizeInputSpaceBetween,
                fontSize: tokens.chipInputFontSize
            }
        },
        radius: tokens.chipRadiusRound,
        border: {
            width: tokens.chipBorderWidth
        },
        // START TODO: talk to Ann about naming conventions
        text: {
            disabled: tokens.chipColorTextDisabled,
            error: tokens.chipColorTextErrorSubtle
        },
        // END TODO: talk to Ann about naming conventions
        static: {
            neutral: {
                text: {
                    default: tokens.chipColorTextStaticNeutral,
                    error: tokens.chipColorTextErrorSubtle,
                    success: tokens.chipColorTextStaticNeutral,
                    warning: tokens.chipColorTextStaticNeutral,
                    info: tokens.chipColorTextStaticNeutral
                },
                background: {
                    default: tokens.chipColorBgStaticNeutralDefault,
                    success: tokens.chipColorBgStaticNeutralSuccess,
                    warning: tokens.chipColorBgStaticNeutralWarning,
                    error: tokens.chipColorBgStaticNeutralError,
                    info: tokens.chipColorBgStaticNeutralInfo
                },
                border: {
                    default: tokens.chipColorBorderStaticNeutralDefault,
                    success: tokens.chipColorBorderStaticNeutralSuccess,
                    warning: tokens.chipColorBorderStaticNeutralWarning,
                    error: tokens.chipColorBorderStaticNeutralError,
                    info: tokens.chipColorBorderStaticNeutralInfo
                }
            },
            emphasis: {
                text: {
                    default: tokens.chipColorTextStaticEmphasis,
                    error: tokens.chipColorTextStaticEmphasis,
                    success: tokens.chipColorTextStaticEmphasis,
                    warning: tokens.chipColorTextStaticEmphasis,
                    info: tokens.chipColorTextStaticEmphasis
                },
                background: {
                    default: tokens.chipColorBgStaticEmphasisDefault,
                    success: tokens.chipColorBgStaticEmphasisSuccess,
                    warning: tokens.chipColorBgStaticEmphasisWarning,
                    error: tokens.chipColorBgStaticEmphasisError,
                    info: tokens.chipColorBgStaticEmphasisInfo
                },
                border: {
                    default: tokens.chipColorBorderStaticEmphasisDefault,
                    success: tokens.chipColorBorderStaticEmphasisSuccess,
                    warning: tokens.chipColorBorderStaticEmphasisWarning,
                    error: tokens.chipColorBorderStaticEmphasisError,
                    info: tokens.chipColorBorderStaticEmphasisInfo
                }
            },
            // TODO: Talk to Ann, these all use the same
            subtle: {
                text: {
                    default: tokens.chipColorTextStaticSubtle,
                    error: tokens.chipColorTextStaticNeutral,
                    success: tokens.chipColorTextStaticSubtle,
                    warning: tokens.chipColorTextStaticSubtle,
                    info: tokens.chipColorTextStaticSubtle
                },
                background: {
                    default: tokens.chipColorBgStaticSubtle,
                    success: tokens.chipColorBgStaticSubtle,
                    warning: tokens.chipColorBgStaticSubtle,
                    error: tokens.chipColorBgStaticSubtle,
                    info: tokens.chipColorBgStaticSubtle
                },
                border: {
                    default: tokens.chipColorBorderStaticSubtle,
                    success: tokens.chipColorBorderStaticSubtle,
                    warning: tokens.chipColorBorderStaticSubtle,
                    error: tokens.chipColorBorderStaticSubtle,
                    info: tokens.chipColorBorderStaticSubtle
                }
            }
        },
        interactive: {
            neutral: {
                text: tokens.chipColorTextInteractiveNeutral,
                background: {
                    default: tokens.chipColorBgInteractiveNeutralDefault,
                    hover: tokens.chipColorBgInteractiveNeutralHover,
                    focus: tokens.chipColorBgInteractiveNeutralFocus,
                    selected: {
                        default: tokens.chipColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.chipColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.chipColorBorderInteractiveNeutralDefault,
                    hover: tokens.chipColorBorderInteractiveNeutralHover,
                    focus: tokens.chipColorBorderInteractiveNeutralFocus,
                    disabled: tokens.chipColorBorderInteractiveDisabled,
                    selected: {
                        default: tokens.chipColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.chipColorBorderInteractiveNeutralSelectedHover
                    }
                }
            },
            emphasis: {
                text: tokens.chipColorTextInteractiveEmphasis,
                background: {
                    default: tokens.chipColorBgInteractiveEmphasisDefault,
                    hover: tokens.chipColorBgInteractiveEmphasisHover,
                    focus: tokens.chipColorBgInteractiveEmphasisFocus,
                    selected: {
                        default: tokens.chipColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.chipColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.chipColorBorderInteractiveEmphasisDefault,
                    hover: tokens.chipColorBorderInteractiveEmphasisHover,
                    focus: tokens.chipColorBorderInteractiveEmphasisFocus,
                    disabled: tokens.chipColorBorderInteractiveDisabled,
                    selected: {
                        default: tokens.chipColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.chipColorBorderInteractiveEmphasisSelectedHover
                    }
                }
            },
            subtle: {
                text: tokens.chipColorTextInteractiveSubtle,
                background: {
                    default: tokens.chipColorBgInteractiveSubtleDefault,
                    hover: tokens.chipColorBgInteractiveSubtleHover,
                    focus: tokens.chipColorBgInteractiveSubtleFocus,
                    selected: {
                        default: tokens.chipColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.chipColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.chipColorBorderInteractiveSubtleDefault,
                    hover: tokens.chipColorBorderInteractiveSubtleHover,
                    focus: tokens.chipColorBorderInteractiveSubtleFocus,
                    disabled: tokens.chipColorBorderInteractiveDisabled,
                    selected: {
                        default: tokens.chipColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.chipColorBorderInteractiveSubtleSelectedHover
                    }
                }
            },
            disabled: {
                background: tokens.chipColorBgInteractiveDisabled,
                border: tokens.chipColorBorderInteractiveDisabled
            }
        }
    };
};
export default chipPalette;
//# sourceMappingURL=chip.js.map